import PropTypes from 'prop-types'
import React from 'react'

import SearchResultsFeedback from './SearchResultsFeedback'
import { SimpleList } from '@/checkout-instore-legacy/components/Commons/Elements/SimpleList'
import Button from '@vtex/styleguide/lib/Button'
import { FormattedMessage } from 'react-intl'

import ResultList from './ResultList'

export default function SearchResults({
  hasNext,
  results,
  onClickSearchResult,
  loading,
  intervalBegin,
  errors,
  retrySearch,
  handleMoreItems,
  nextLoading,
  loadingProducts,
}) {
  return (
    <section id="searchresults" className="pb4">
      <SimpleList>
        <div className="nv4">
          <ResultList
            items={results}
            intervalBegin={intervalBegin}
            loadingProducts={loadingProducts}
            onClickMoreDetails={onClickSearchResult}
          />
          {hasNext || nextLoading ? (
            <div className="mv6" data-cy="show-more-products-button">
              <Button
                variation="tertiary"
                size="large"
                onClick={handleMoreItems}
                isLoading={nextLoading}
                block
              >
                <FormattedMessage id="showMoreProducts" />
              </Button>
            </div>
          ) : null}
          {loading || (errors && errors.length) ? (
            <SearchResultsFeedback
              retrySearch={retrySearch}
              loading={loading}
              errors={errors}
            />
          ) : null}
        </div>
      </SimpleList>
    </section>
  )
}

SearchResults.propTypes = {
  nextLoading: PropTypes.bool,
  hasNext: PropTypes.bool,
  results: PropTypes.array,
  errors: PropTypes.object,
  loading: PropTypes.bool,
  loadingProducts: PropTypes.bool,
  intervalBegin: PropTypes.number,
  onClickSearchResult: PropTypes.func,
  retrySearch: PropTypes.func,
  handleMoreItems: PropTypes.func.isRequired,
}
